// extracted by mini-css-extract-plugin
export default {"buttonLogout":"ModalLogOut_buttonLogout__wpsHB","logOut":"ModalLogOut_logOut__-gEqg"};